<template>
  <div id="app">
    <!-- 使用 router-view 作为根组件容器，路由会自动渲染对应的页面 -->
    <!-- 
    组件缓存 在切换组件的<router-view>中添加keep-alive标签 将前者包裹起来 被包裹起来的组件 会被缓存起来 不会销毁
     -->

    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
}
</style>





<!-- 


-->